import * as firebase from 'firebase/app'
import "firebase/auth"
import "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyCXpTGvZe_vllKJwBzzZKf5Jzz16yQZ4OA",
  authDomain: "todo-auth-76c3c.firebaseapp.com",
  databaseURL: "https://todo-auth-76c3c.firebaseio.com",
  projectId: "todo-auth-76c3c",
  storageBucket: "todo-auth-76c3c.appspot.com",
  messagingSenderId: "1031113913950",
  appId: "1:1031113913950:web:402a9ab305e3a5f534e6cf"
};
firebase.initializeApp(firebaseConfig)

export const auth = firebase.auth()

export const database = firebase.firestore()

export default firebase